let Sdata=[
    {
        id: 1,
        imgSrc:"https://www.designfreelogoonline.com/wp-content/uploads/2014/10/Custom-made-Logo-Design-Brand-Identity-luxury-packages.jpg",
        sname:"Logo & Branding",
         cname:"Need to make a lasting impression? The right combination of colors, shapes and words will define your brand. Get the perfect logo and ensure your branding hits the spot with these services.",
          link:""
    },
    {
        id: 2,
        imgSrc:"https://www.cainfotechindia.com/webdesign_blog/wp-content/uploads/2020/05/0.gif",
        sname:"Web Design Services",
         cname:"Looking to make a mark on the world wide web? Whether you need a new design for a custom built website or a design for a popular CMS platform you'll find the perfect web design with these design services.",
          link:"https://www.hbo.com/game-of-thrones"
    },
    {
        id: 3,
        imgSrc:"https://d3re0f381bckq9.cloudfront.net/41744578_images-15_650x459.jpg",
        sname:"Print Design Services",
         cname:"Sending something to print can be so final! Don't make the mistake of having a mistake - get the design right the first time, whether it's a flyer, poster or sticker. Check out all our print design services.",
          link:"https://www.starz.com/us/en/series/spartacus/5972"
    },
    {
        id: 4,
        imgSrc:"https://miro.medium.com/max/1000/1*n7njkImFXybH0acD_e07pA.jpeg",
        sname:"Graphic Design Services",
         cname:"Really need some design inspiration? Someone who can use their creative skills to make a design that will really pop? These graphic design services may be just what you're looking for.",
          link:"https://www.cinemax.com/banshee"
    },
    {
        id: 5,
        imgSrc:"https://99designs-blog.imgix.net/blog/wp-content/uploads/2016/09/ultimate-guide-product-packaging.jpg?auto=format&q=60&w=2060&h=1545&fit=crop&crop=faces",
        sname:"Product & Merchandise Design Services",
         cname:"Need some walking advertising? A little promotional gear for the team manning the tradeshow booth? Get custom apparel, mugs or caps from our professional designers.",
          link:"https://www.foxtv.co.uk/shows/fox/prison-break"
    },
    {
        id: 6,
        imgSrc:"https://www.avidteck.com/resources/page_image/s_6051529830317.jpg",
        sname:"Art & Illustration",
         cname:"Not everyone is an artist - but the designers at DesignCrowd definitely are. Whether you need a mascot designed for your sporting team or a piece of custom wall art you'll find what you need with these design.",
          link:"https://vampirediariesonline.com/miscellaneous/the-vampire-diaries-official-site-on-cwtvcom/"
    },
    {
        id: 7,
        imgSrc:"https://ziplocal.com/wp-content/uploads/2018/08/Laptop-and-Mobile-devices.jpg",
        sname:"Web Design (UX/UI)",
         cname:"From B2B to B2C websites, Buzz Interactive provides quality web, UI and UX design services that are pixel perfect and uses a responsive design approach to make it work on all devices and make your website.",
          link:"https://www.netflix.com/pk/title/70283261"
    },
    {
        id: 8,
        imgSrc:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTeIFYc3jmNxHlmBe47YKHoqrjL-khmrF1Xzw&usqp=CAU",
        sname:"Brand & Stationary Design",
         cname:"We offer a complete range of quality brand identity design services, stationery design services, company rebranding services,brand guidelines services, and branding consultation.",
          link:"https://peakyblinders.tv/"
    },
    {
        id: 9,
        imgSrc:"https://www.localwebdesignconsultant.com.au/wp-content/uploads/2016/04/Graphic-Design-Course.jpg",
        sname:"Print Design",
         cname:"Your printed marketing material can make a significant impact on your company’s image. We provide quality print design services to make sure that your business cards, letterheads.",
          link:"https://www.netflix.com/pk/title/80192098"
    }
]
export default Sdata;